<template>
<div class="chapter">
<div class="inner_page">
<div style="padding-top:22%;">
<a id="oo2"><img alt="1" src="images/1.jpg"/></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page2.vue?f691c93c